import * as THREE from 'three'
import { powerUpRaisedYOffset } from '../../config/constants'
import { powerUpPositions, type PathPowerUpPlacement } from '../../config/powerUpPositions'
import { POWER_UP_CONFIG } from './powerUpConfig'

export type IndexedPowerUpPlacement = PathPowerUpPlacement & {
    powerUpIndex: number
}

export function collectAnimScale(progress: number): number {
    const baseScale = POWER_UP_CONFIG.baseScale
    const collectScalePeak = POWER_UP_CONFIG.collectScalePeak

    if (progress < 0.5) {
        return THREE.MathUtils.lerp(baseScale, baseScale * collectScalePeak, progress / 0.5)
    }

    return THREE.MathUtils.lerp(baseScale * collectScalePeak, 0, (progress - 0.5) / 0.5)
}

export function resolvePowerUpYOffset(up: 0 | 1 | 2) {
    if (up === 2) return powerUpRaisedYOffset
    if (up === 1) return powerUpRaisedYOffset * 0.5
    return 0
}

export function getCollectablePowerUpPlacements(): IndexedPowerUpPlacement[] {
    return powerUpPositions.flatMap((placement, powerUpIndex) =>
        placement.type === 'heart' || placement.type === 'coin'
            ? [{ ...placement, powerUpIndex }]
            : [],
    )
}

export function getOrbPowerUpPlacements(): IndexedPowerUpPlacement[] {
    return powerUpPositions.flatMap((placement, powerUpIndex) =>
        placement.type === 'battery' || placement.type === 'plane' || placement.type === 'shield'
            ? [{ ...placement, powerUpIndex }]
            : [],
    )
}
